<template>
    <div class="filter-list">
        <ul
            :class="classList"
            class="list"
        >
            <slot></slot>
        </ul>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
    noIcons?: boolean
}>()

const classList = computed(() => ({
    'no-icons': props.noIcons,
}))
</script>

<style lang="scss" scoped>
.filter-list {
    flex-wrap: wrap;

    .list {
        display: grid;
        grid-auto-rows: auto;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;

        @include min-width(410) {
            grid-template-columns: repeat(4, 1fr);
        }

        :slotted(.filter-item) {
            &.no-icons {
                margin: 0 16px 28px 0;

                @include min-width(1024) {
                    margin: 0 16px 20px 0;
                }
            }
        }

        &.no-icons {
            flex-wrap: nowrap;
            display: block;
            columns: 1;

            @include min-width(410) {
                columns: 2;
                padding-left: 10px;
            }
        }
    }
}
</style>
